import { Usp } from "@/components/Blocks/usps/components/usp";
import { useUspsContext } from "@/components/Blocks/usps/context/usps.context";
import { Base } from "@/components/Blocks/usps/usps.base";

export const Usps = Object.assign(Base, {
    useContext: useUspsContext,
    Usp: Usp
});
